import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Range, isValidDateRange } from '@navfleet/client/shared/models/common';
import { Earthquake, TectonicPlate } from '@navfleet/client/weather/earthquake/domain/models';
import { environment } from '@navfleet/shared/core/environment';
import { throwError } from 'rxjs';

export const WEATHER_EARTHQUAKE_API = `${environment.NAVFLEET_BACKEND}/api/v1/weather/earthquakes`;

export const TECTONIC_PLATES_API = `${environment.NAVFLEET_BACKEND}/api/v1/weather/tectonic-plates`;

@Injectable({
    providedIn: 'root',
})
export class WeatherEarthquakeApi {
    private readonly http = inject(HttpClient);

    public getEarthquake(range: Range<Date>) {
        if (!isValidDateRange(range)) {
            throw throwError(() => new Error('EARTHQUAKE.API.INVALID_DATE_RANGE'));
        }
        const params = new HttpParams().set('from', range.from.toISOString()).set('to', range.to.toISOString());
        return this.http.get<Earthquake[]>(WEATHER_EARTHQUAKE_API, { params });
    }

    public getTectonicPlates() {
        return this.http.get<TectonicPlate[]>(TECTONIC_PLATES_API);
    }
}
